import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Producto } from '@shared/models/abm/Producto';

@Component({
  selector: 'app-consolidado',
  templateUrl: './consolidado.component.html',
  styleUrls: ['./consolidado.component.scss']
})
export class ConsolidadoComponent {

  productoSeleccionado : Producto;
  obteniendoDatos: boolean;
  busquedaFormControl = new UntypedFormControl();
  productoBuscado:string;

  constructor(
    private spinner: NgxSpinnerService
  ) { }

  filtrarProductos() {
    this.productoBuscado = this.busqueda.value;
  }

  usuarioSeleccionoProducto(producto: Producto) {
    this.productoSeleccionado = producto;
  }

  mostrarLoading(){
    this.obteniendoDatos = true;
    this.spinner.show('spinnerGrafico');
  }

  ocultarLoading(){
    this.obteniendoDatos = false;
    this.spinner.hide('spinnerGrafico');
  }

  get busqueda() {
    return this.busquedaFormControl;

  }
}
